import { useId } from 'react';

/** Original SVG character: gestures cue the lesson; expression follows actual
 * audio playback, rather than a perpetual attention-seeking animation. */
export function TutorAvatar({
  speaking = false,
  pointing = false,
  small = false,
}: {
  speaking?: boolean;
  pointing?: boolean;
  small?: boolean;
}) {
  const id = useId().replaceAll(':', '');
  return (
    <svg
      className={`tutor-avatar ${speaking ? 'speaking' : ''} ${pointing ? 'pointing' : ''} ${small ? 'small' : ''}`}
      viewBox="0 0 180 190"
      aria-hidden="true"
    >
      <defs>
        <radialGradient id={`${id}-shell`} cx="30%" cy="20%" r="90%">
          <stop stopColor="#ffffff" />
          <stop offset=".5" stopColor="#e8efcf" />
          <stop offset="1" stopColor="#a0ba84" />
        </radialGradient>
        <linearGradient id={`${id}-face`} x2=".8" y2="1">
          <stop stopColor="#315b54" />
          <stop offset="1" stopColor="#163a36" />
        </linearGradient>
        <linearGradient id={`${id}-scarf`} x2="0" y2="1">
          <stop stopColor="#ecc681" />
          <stop offset="1" stopColor="#c99249" />
        </linearGradient>
      </defs>
      <ellipse cx="91" cy="178" rx="43" ry="7" fill="#446443" opacity=".15" />
      <g className="tutor-body">
        <path
          d="M64 132q-11 11-9 26 10 9 22-2l7-23M103 134l1 24q15 9 23-2-1-14-11-24"
          fill="#b9cd9e"
          stroke="#94ac7e"
          strokeWidth="1.5"
        />
        <path
          d="M53 104q-10 39 14 49 22 8 46-1 23-14 13-48Z"
          fill={`url(#${id}-shell)`}
          stroke="#99ad88"
          strokeWidth="1"
        />
        <path
          d="M125 110q18-3 21 17"
          stroke="#b4c99c"
          strokeWidth="13"
          strokeLinecap="round"
          fill="none"
        />
        <g className="tutor-arm">
          <path
            d="M58 112q-19-7-26-24"
            stroke="#bbcea1"
            strokeWidth="14"
            strokeLinecap="round"
            fill="none"
          />
          <circle cx="29" cy="82" r="10" fill="#e7edcf" />
          <path
            d="m27 80-6-14"
            stroke="#d5e1b8"
            strokeWidth="7"
            strokeLinecap="round"
          />
        </g>
        <path
          d="M60 103q30 13 62-1l-1 16q-32 13-62 0Z"
          fill={`url(#${id}-scarf)`}
        />
        <path d="m113 114 9 27-18-5 0-20" fill="#d4a35a" />
        <rect
          x="32"
          y="33"
          width="118"
          height="82"
          rx="36"
          fill={`url(#${id}-shell)`}
          stroke="#a4b98c"
          strokeWidth="1.5"
        />
        <path d="M83 33Q66 9 90 12q10 3 5 19" fill="#82a76d" />
        <path d="M90 32q9-26 25-18-2 16-25 18" fill="#c0d59e" />
        <rect
          x="46"
          y="48"
          width="90"
          height="51"
          rx="23"
          fill={`url(#${id}-face)`}
        />
        <path
          d="M57 53q32-8 66 1"
          stroke="#75a088"
          opacity=".4"
          strokeWidth="2"
          fill="none"
        />
        <g className="tutor-eyes" fill="#e4f2c2">
          <ellipse cx="70" cy="70" rx="4.2" ry="6" />
          <ellipse cx="111" cy="70" rx="4.2" ry="6" />
        </g>
        <path
          className="tutor-smile"
          d="M84 82q7 7 14 0"
          stroke="#e6edc6"
          strokeWidth="3"
          strokeLinecap="round"
          fill="none"
        />
        <ellipse
          className="tutor-mouth"
          cx="91"
          cy="84"
          rx="6"
          ry="5"
          fill="#e6edc6"
        />
        <circle cx="60" cy="81" r="5" fill="#82ad8b" opacity=".4" />
        <circle cx="121" cy="81" r="5" fill="#82ad8b" opacity=".4" />
        <path d="m85 132 5-8 5 8-5 8Z" fill="#6f9863" />
      </g>
    </svg>
  );
}
